<template>
    <div class="animated fadeIn">
      <div class="card card-green">
        <div class="card-body">
          <div class="row">
            <div class="col-sm-12  table-responsive">
                <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                  <thead>
                    <tr>
                        <th></th>
                      <th @click="sortGrid('startTime')">
                          {{$t('DATETIME')}}
                          <img src="../../../assets/img/table-arrow.svg" v-if="pagination.sort == null || pagination.sort !== 'startTime'" />
                          <img src="../../../assets/img/table-arrow.svg" class="active" v-if="pagination.sort == 'startTime' && pagination.dir == 'asc'" />
                          <img style="transform: rotateX(180deg);" src="../../../assets/img/table-arrow.svg" class="active" v-if="pagination.sort == 'startTime' && pagination.dir == 'desc'" />
                      </th>
                      <th>
                        {{$t('NAME')}}
                      </th>
                      <th>{{$t('ACTION')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="item in response.root">
                      <tr :key="`${item.workingGroupId}_${item.eventId}`" aria-rowindex="1" class=" table-ellipsis">
                        <td>
                          <icon v-if="item.isExpanded === false" @click="item.isExpanded = true" icon="plus" class="hover-mouse"></icon>
                          <icon v-if="item.isExpanded === true" @click="item.isExpanded = false" icon="minus" class="hover-mouse"></icon>
                        </td>
                        <td>{{moment.utc(item.startTime).local().format('DD.MM.YYYY HH:mm:ss')}}</td>
                        <td>{{item.name}}</td>
                        <td>
                          <button type="button" class="btn button-edit mr-2"  @click="showEventModal(item)">{{$t('EDITEVENTDATE')}}</button>
                          <button type="button" class="btn button-edit mr-2"  @click="showChildModal(item)">{{$t('CHILDRENONEVENT')}}</button>
                          <button type="button" class="btn button-edit mr-2"  @click="showModal(item)">{{$t('ADDDESCRIPTION')}}</button>
                        </td>
                      </tr>
                      <tr v-if="item.isExpanded === true" :key="`${item.workingGroupId}_${item.eventId}_sec`" class=" table-ellipsis">
                        <td></td>
                        <td v-html="item.description" colspan="3"></td>
                      </tr>
                    </template>
                  </tbody>
                </table>
                <nav>
                  <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData">
                  </pagination>
                </nav>
            </div>
          </div>
        </div>
      </div>
      <WorkingGroupEventForm v-model="formData" v-on:close="formData = null; getData()" />
      <EventForm v-model="formEventData" v-on:close="formEventData = null; getData()" />
      <WorkingGroupChildEventForm v-model="formDataChild" v-on:close="formDataChild = null; getData()" />
    </div>
  </template>
  
  <script>
  import moment from 'moment';
  import Api from '@/api/working_group/WorkingGroup';
  import EventForm from './EventForm.vue';
  import WorkingGroupEventForm from './WorkingGroupEventForm';
  import WorkingGroupChildEventForm from './WorkingGroupChildEventForm';
  
  export default
  {
      name: 'WorkingGroupEventWin',
      components:
    {
      EventForm,
      WorkingGroupEventForm,
      WorkingGroupChildEventForm
    },
      data()
      {
          return {
              response:
        {},
              formData:  null,
              formEventData:  null,
              formDataChild:  null,
              pagination:
        {
            query: '',
            currentPage: 1,
            limit: 25,
            searchTimeout: false,
        },
          };
      },
      created()
      {
          const me = this;
          me.getData();
      },
      methods:
    {
        async getData()
        {
            const me = this;
            try
            {
                const data = await Api.selectWorkingGroupEvent(me.getParams);
                if (data.error && data.error === true)
                {
                    me.$notify.notice(data);
                    me.loading = false;
                    return;
                }

                for (const item of data.root)
                {
                  item.isExpanded = false;
                }
  
                me.response = data;
            }
            catch (e)
            {
                me.$notify.notice(e);
            }
        },
        showEventModal(item)
        {
            const me = this;
            let data = {};
            if (typeof item !== 'undefined')
            {
                data = { ...item };
            }
            
            me.formEventData = data;
        },
        showModal(item)
        {
            const me = this;
            let data = {};
            if (typeof item !== 'undefined')
            {
                data = { ...item };
            }
            
            me.formData = data;
        },
        showChildModal(item)
        {
            const me = this;
            let data = {};
            if (typeof item !== 'undefined')
            {
                data = { ...item };
            }
            
            me.formDataChild = data;
        },
        sortGrid(key)
        {
            const me = this;

            me.pagination.sort = key;
            if (me.pagination.dir === 'asc')
            {
                me.pagination.dir = 'desc';
            }
            else
            {
                me.pagination.dir = 'asc';
            }

            // eslint-disable-next-line prefer-object-spread
            me.pagination = Object.assign({}, me.pagination);
        },
    },
      watch:
    {
        'pagination.limit'()
        {
            const me = this;
            me.getData();
        },
        'pagination.dir'()
        {
            const me = this;
            me.getData();
        },
        'pagination.currentPage'()
        {
            const me = this;
            me.getData();
        },
        'pagination.query'()
        {
            const me = this;
  
            if (me.pagination.searchTimeout !== false)
            {
                clearTimeout(me.pagination.searchTimeout);
            }
  
            me.pagination.searchTimeout = setTimeout(() =>
            {
                me.getData();
                me.pagination.searchTimeout = false;
            }, 300);
        },
    },
      computed:
    {
        getParams()
        {
            const me = this;
            const data = {
                ...me.pagination,
            };
            data.start = (data.currentPage - 1) * data.limit;
            data.workingGroupId = me.$route.params.workingGroupId;
            return data;
        },
    },
  };
  </script>
  